<template>
  <div>
    <h1 class="display-heading">Company Admins</h1>

    <div class="mb-3">
      <router-link
        :to="{ name: 'company-admins-create' }"
        class="btn btn-primary btn-primary-insv"
        >Create New Admin</router-link
      >
    </div>
    <div ref="tableSection">
      <div class="table-responsive">
        <table ref="listTable" class="table table-hover">
          <col width="50" />
          <col width="300" />
          <col />
          <col width="150" />
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Email Address</th>
              <th scope="col">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-show="adminList.length === 0">
              <td :colspan="columnsCount" class="text-center font-italic">
                {{ isTableLoading ? "Loading Data" : "No Data" }}
              </td>
            </tr>
            <tr v-for="(admin, index) in adminList" :key="index">
              <td>
                {{
                  (pagination.currentPage - 1) * pagination.pageSize + index + 1
                }}
              </td>
              <td>
                {{ admin.fullName }}
              </td>
              <td>
                {{ admin.email }}
              </td>
              <td>
                <button v-if="!admin.isSelf" class="btn btn-danger btn-sm" @click="deleteAdmin(admin.id)">
                  Delete Admin
                </button>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination
      v-model="pagination.currentPage"
      :totalPages="pagination.totalPages"
      :scrollPosition="pagination.scrollPosition"
    >
    </pagination>

    <popup-modal
      ref="popupDeleteAdminConfirmation"
      :hasCloseButton="false"
      title="Confirm Delete Admin"
    >
      <template slot="content">
        <p>Are you sure you want to delete this company admin?</p>
        <p>
          Once deleted this user will no longer have access to the system
          anymore.
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="btn btn-danger" @click="confirmDeletion">
          Delete Admin
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click="dismissDeletion"
        >
          Cancel
        </button>
      </template>
    </popup-modal>
  </div>
</template>

<script>
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'CompanyAdmins',
    'components': {
        pagination,
        popupModal
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'adminList': [],
            'adminIdPendingDeletion': 0
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getAdmins();
            });
        }
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getAdmins();

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition =
        this.$refs.tableSection.getBoundingClientRect().top +
        window.scrollY -
        document.querySelector('.top-navigation').clientHeight;
        });
    },
    'methods': {
        getAdmins () {
            this.isTableLoading = true;
            this.axios
                .post('Company/GetAdmins', {
                    'p': this.pagination.currentPage,
                    'ps': this.pagination.pageSize
                })
                .then(({ data }) => {
                    this.isTableLoading = false;
                    let pagedResult = data.data;

                    this.pagination.currentPage = pagedResult.p;
                    this.pagination.totalPages = pagedResult.c;

                    this.adminList = pagedResult.l;
                });
        },
        deleteAdmin (adminId) {
            this.adminIdPendingDeletion = adminId;
            this.$refs.popupDeleteAdminConfirmation.show();
        },
        confirmDeletion () {
            this.$refs.popupDeleteAdminConfirmation.hide(() => {
                this.axios.delete('Company/DeleteAdmin', {
                    'params': {
                        'userId': this.adminIdPendingDeletion
                    }
                }).then(() => {
                    this.getAdmins();
                });
            });
        },
        dismissDeletion () {
            this.adminIdPendingDeletion = 0;
            this.$refs.popupDeleteAdminConfirmation.hide();
        }
    }
};
</script>
